import { Model } from '@/app/shared/models/model';
import { CampaignFrequencyType } from '@/app/shared/enums';

export class CampaignFrequency extends Model {
  public CampaignId!: string;
  public Day!: string | null;
  public Frequency!: CampaignFrequencyType;
}
